import type { RawBusiness, Business } from "../types/business";

export const getBusinessId = (b?: RawBusiness | null) =>
	b?.id || b?._id || b?.businessId || b?.placeId;

export const getBusinessName = (b?: RawBusiness | null) =>
	b?.name || b?.displayName || b?.businessName || "Business";

export const getBusinessAddress = (b?: RawBusiness | null) =>
	b?.address ||
	b?.formattedAddress ||
	b?.formatted_address ||
	"No address available";

export const getBusinessRating = (b?: RawBusiness | null) =>
	Number(b?.avgRating || b?.averageRating || b?.rating || 0);

export const getBusinessReviewCount = (b?: RawBusiness | null) =>
	Number(b?.totalReviews || b?.totalRatings || b?.reviewCount || b?.userRatingCount || 0);

export const normalizeBusiness = (source?: RawBusiness | null): Business => {
	const rating = getBusinessRating(source);
	const reviewCount = getBusinessReviewCount(source);
	return {
		id: source?.id || source?._id || source?.placeId,
		placeId: source?.placeId || source?.id || source?._id,
		name: getBusinessName(source),
		address: getBusinessAddress(source),
		avgRating: rating,
		averageRating: rating,
		totalReviews: reviewCount,
		totalRatings: reviewCount,
		connectionStatus: source?.connectionStatus,
		createdAt: source?.createdAt,
	};
};
